export interface MtApplicationAcceptSuccessPageData {
  priceValue: number;
}

export interface MtApplicationAcceptSuccessPageProps extends MtApplicationAcceptSuccessPageData {}
